import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

/**
 * Reusable shell for the static legal pages (Terms, Privacy).
 * Pure layout / typography — zero side-effects.
 */
export default function LegalPage({ title, updated, children }) {
  return (
    <div className="min-h-screen flex flex-col" data-testid="legal-page">
      <Header />
      <main id="main-content" className="flex-1 max-w-3xl w-full mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <div className="mb-6">
          <Link to="/" className="label-mono text-white/45 hover:text-white">
            ← Back to home
          </Link>
        </div>
        <h1 className="text-3xl sm:text-4xl text-white font-semibold tracking-tight leading-tight">
          {title}
        </h1>
        {updated && (
          <div className="label-mono mt-2 text-white/45">Last updated · {updated}</div>
        )}
        <article className="prose prose-invert mt-8 text-white/75 leading-relaxed text-[15px] space-y-5">
          {children}
        </article>
      </main>
      <Footer />
    </div>
  );
}
